import { useCallback, useMemo } from "react"
import { getPlayersPositions } from "../../api/index.js"
import { useFetch } from "../../filters/useFetch.js"

export const usePositionPlayerFeuilleMatch = (composition, {width, height}, isSmall) => {

    // Dispatch pour récupérer les positions

    const URLgetPlayersPositions = useCallback(() => {

        return getPlayersPositions(composition, {width, height})

    }, [composition, width, height])

    const filters = useMemo(()  => {
        return {}

    }, [])

    const [playersPosition, loading] = useFetch(URLgetPlayersPositions, filters, undefined, '')

    return [playersPosition]

}